module.exports = __webpack_public_path__ + "static/media/game-sound-success.e10fb2df.mp3";